export default function progressPagination() {
    if (document.querySelector(".progress-pagination")) {
        let slides = document.querySelectorAll(".banner .swiper-slide");
        let progressbar = document.querySelector(".progress-pagination");

        slides.forEach(slide => {

            if (slide.classList.contains("swiper-slide-active")) {
                progressbar.classList.remove("active");
                progressbar.classList.add("active");
            }
        });
    }
}